import { isFunction } from "lodash"
import MerchantAppData from "../Model/MerchantAppData"

export default class ReactHelper {
    /**
     * Similar to implementation of useEffect(yourCallback, [item1, item2,...]), where
     * callback will be fired whenever item1, item2, etc is changed.
     *
     * For key {"a": 10, "b": 20}, we will compare component's
     * "_a" value with 10, and "_b" value with 20, if value changes,
     * then will fire callback. We can take multiple key value in this format
     *
     * Place this function call inside componentDidUpdate like
     * componentDidUpdate() {
     *      handleComponentDidUpdate(this,["sessions", "allOrders", {"a": 10, "b": 20}], yourCallback)
     * }
     */
    static handleComponentDidUpdate = (component, keyToObserveForChange, handleChangeFunction) => {
        let toUpdate = {}
        let app = component.isRootApp ? component : (component.props.app || MerchantAppData.data)
        let isNeedInvokeChangeFunction = false
        let simpleKeyValueChange = []
        keyToObserveForChange.forEach(key => {
            if (isFunction(key)) {
                let value = key()

                // Custom function explicitly return true, so just invoke the handle change function
                // later, even if all the observed value do not change
                if (value === true) {
                    isNeedInvokeChangeFunction = true
                    return
                }
                else {
                    // function return extra key:value for us to run the comparison,
                    // pass the unwrapped value to be further processed
                    key = value
                }
            }

            if (key instanceof Object) {
                Object.keys(key).forEach(subKey => {
                    if (component.state["_"+subKey] !== key[subKey]) {
                        toUpdate["_"+subKey] = key[subKey]
                    }
                })
            }
            else if (app.state[key] !== component.state["_"+key]) {
                toUpdate["_"+key] = app.state[key]
                // Simple key value change, take note and notify caller
                simpleKeyValueChange.push(key)
            }
        })
        if (Object.keys(toUpdate).length > 0) {
            component.setState(toUpdate, () => {
                handleChangeFunction(simpleKeyValueChange)
            })
        }
        else if (isNeedInvokeChangeFunction) {
            handleChangeFunction(simpleKeyValueChange)
        }
    }
}